import type { FastifyInstance } from 'fastify'
import type { Firestore } from 'firebase-admin/firestore'
import type { RedisClient } from '../../core/redis/client.js'
import { CollabController } from './collab.controller.js'
import { collabRoutes } from './collab.routes.js'

export default async function collabModule(
  app: FastifyInstance,
  firestore: Firestore,
  redis: RedisClient
) {
  const controller = new CollabController(redis, firestore)
  await collabRoutes(app, controller)
}
